import type { ICampaignGroup, ICampaignGroupTemplate } from '~/modules/campaign-group/types';
import type { ICampaignTemplate } from '~/modules/campaign-template/types';

import { useMutationCampaignGroupState } from '~/modules/campaign-group/hooks';
import { CAMPAIGN_STATUS, CAMPAIGN_TYPE } from '~/constants/campaign';
import { useGModalConfirm } from '~/presentation/common';
import { useCGTemplateContext } from '../contexts';
import { GTextContents } from '~/presentation/ui';
import { useState } from 'react';

export const useCGTemplateEnded = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { handleOpenModalConfirm } = useGModalConfirm();
  const { handleSetCampaignGroup } = useCGTemplateContext();
  const { handleUpdateCampaignGroupState } = useMutationCampaignGroupState();
  const onChangeStateCampaign = async (
    campaignGroup: ICampaignGroup,
    status: ICampaignGroup['status'],
  ) => {
    try {
      setIsLoading(true);
      const updateCampaign: ICampaignGroupTemplate = {
        ...campaignGroup,
        status,
        type: CAMPAIGN_TYPE.TEMPLATE_BUNDLE as ICampaignGroupTemplate['type'],
        campaigns: campaignGroup.campaigns?.map((campaign) => ({
          ...campaign,
          status,
        })) as ICampaignTemplate[],
      };
      const campaignGroupUpdated = await handleUpdateCampaignGroupState(updateCampaign);
      updateCampaign.versions = campaignGroupUpdated?.versions;
      handleSetCampaignGroup(updateCampaign);
    } catch (error) {
      throw new Error((error as Error).message);
    } finally {
      setIsLoading(false);
    }
  };
  const onEndCampaign = async (campaign: ICampaignGroup) => {
    if (!campaign) return;

    handleOpenModalConfirm({
      id: campaign.id,
      title: 'End test experiment',
      message: GTextContents({
        blockStackProps: {
          gap: '600',
        },
        contents: [
          {
            content:
              'Once a test is ended, it cannot be restarted. However, the templates linked to the variants in this experiment can be used for other experiments.',
          },
          {
            content: 'Do you want to proceed with ending it?',
          },
        ],
      }),
      primaryAction: {
        content: 'End experiment',
        onAction: () => onChangeStateCampaign(campaign, CAMPAIGN_STATUS.STOPPED),
      },
    });
  };
  return {
    isEndingCampaign: isLoading,
    onEndCampaign,
  };
};
